import React, {useState} from 'react';
import MainLayout from 'Components/Layout/MainLayout';
import ProForm from 'Components/ProForm';
import SelectDict from 'Features/Select/SelectDict';
import {Button, Input} from 'antd';
import ProTable, {ProTableColumnsType} from 'Components/ProTable';
import {FlexBox} from 'Components/FlexBox';
import {LinkButton} from 'Features/Buttons/LinkButton';
import {ExportOutlined, ImportOutlined} from '@ant-design/icons';
import {exportExcel, MenuItem, menuList, QueryMenuList} from './service';
import useRequest from 'Utils/Hooks/useRequest';
import usePagination from 'Utils/Hooks/usePagination';
import {getPagedIndex} from 'Utils/common';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import {MenuModal} from './Components/MenuModal';
import {pick} from 'lodash-es';
import {useDict} from './useDict';
import {ActionDrawer} from './Components/ActionDrawer';
import {ImportExcelModal} from './Components/ImportExcelModal';
import {ImportExcel2Modal} from './Components/ImportExcel2Modal';
import useRequestFn from '../../../Utils/Hooks/useRequestFn';
import ImportLog from '../../../Components/ImportLog';
import {Auth} from '../../../Features/Auth';

export function MenuManage() {
    const menuModal = useModalHandler({component: MenuModal});
    const importExcelModal = useModalHandler({component: ImportExcelModal});
    const importExcel2Modal = useModalHandler({component: ImportExcel2Modal});

    const actionDrawer = useModalHandler({
        component: ActionDrawer,
        type: 'drawer',
    });

    const dict = useDict();

    const [query, setQuery] = useState<QueryMenuList>({});

    const {params, tableProps} = usePagination(100);

    const [data, {loading}, refresh] = useRequest(
        () => menuList(query, params),
        {},
        [query, params],
    );

    const [download, downloadStatus] = useRequestFn(() => exportExcel(query));

    function onSaveOk() {
        menuModal.close();
        refresh();
    }

    const columns: ProTableColumnsType<MenuItem> = [
        {
            title: '序号',
            width: 80,
            render: (_, _item, index) => getPagedIndex(index, params),
        },
        {title: '名称', dataIndex: 'name'},
        {title: '编码', dataIndex: 'code', width: 300},
        {title: '类型', dataIndex: 'levelType', render: dict.MenuType.getName},
        {title: '排序', dataIndex: 'sort', width: 80},
        {
            title: '操作',
            align: 'right',
            width: 300,
            render: (_, item) => (
                <ProTable.Operate>
                    <LinkButton
                        onClick={() =>
                            menuModal.open({
                                action: 'edit',
                                data: item,
                                onOk: onSaveOk,
                            })
                        }>
                        编辑
                    </LinkButton>

                    {item.levelType !== 'DIMTYPE100001' && (
                        <Auth code="hmenu_operation_item_settings">
                            <LinkButton
                                onClick={() => actionDrawer.open({menu: item})}>
                                操作项设置
                            </LinkButton>
                        </Auth>
                    )}

                    <LinkButton
                        onClick={() =>
                            menuModal.open({
                                action: 'add',
                                data: pick(item, ['levelType', 'parentId']),
                                onOk: onSaveOk,
                            })
                        }>
                        增加同级
                    </LinkButton>
                </ProTable.Operate>
            ),
        },
    ];

    const toolBar = (
        <FlexBox justifyContent="space-between" flex={999}>
            <FlexBox gap="20px">
                <Button
                    type="primary"
                    ghost
                    icon={<ImportOutlined />}
                    onClick={() => importExcelModal.open()}>
                    Excel 导入菜单数据
                </Button>

                <Button
                    type="primary"
                    ghost
                    icon={<ImportOutlined />}
                    onClick={() => importExcel2Modal.open()}>
                    Excel 导入功能数据
                </Button>

                <Button
                    type="default"
                    icon={<ExportOutlined />}
                    onClick={download}
                    loading={downloadStatus.loading}>
                    Excel 导出全部数据
                </Button>
            </FlexBox>

            <ImportLog
                logUrl="/function/getImportErrorPage"
                downloadUrl="/function/exportImportError"
            />
        </FlexBox>
    );

    return (
        <MainLayout.SpaceWrapper padding>
            <ProForm.Query defaultExpand onFinish={setQuery}>
                <ProForm.Field label="类型" name="levelType">
                    <SelectDict options={dict.MenuType.data} allowClear />
                </ProForm.Field>

                <ProForm.Field label="名称" name="name">
                    <Input placeholder="请输入名称" />
                </ProForm.Field>
            </ProForm.Query>

            <ProTable
                rowKey="id"
                columns={columns}
                dataSource={data?.data}
                toolBar={toolBar}
                loading={loading}
                expandable={{
                    showExpandColumn: false,
                }}
                {...tableProps(data?.total)}
            />

            {menuModal.render()}
            {actionDrawer.render()}
            {importExcelModal.render()}
            {importExcel2Modal.render()}
        </MainLayout.SpaceWrapper>
    );
}
